module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (49).560ec048.jpg";